export type StandaloneChargePayerType =
  | 'individual'
  | 'company'
  | 'INDIVIDUAL'
  | 'COMPANY';

export function isCompanyPayer(payerType?: StandaloneChargePayerType | string | null): boolean {
  const normalized = String(payerType || '').toUpperCase();
  return normalized === 'COMPANY';
}

export function getPayerDocumentLabel(payerType?: StandaloneChargePayerType | string | null): string {
  return isCompanyPayer(payerType) ? 'CNPJ' : 'CPF';
}
